import { TaggedLogger } from './TaggedLogger';

export const createTaggedLogger = (name: string) => {
  return new TaggedLogger(name);
};
